// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"40d27acc","554":"148cc40f"}[chunkId] + ".chunk.js";
};